'use client';

import * as React from 'react';
export const CalendarGridDayCellContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") CalendarGridDayCellContext.displayName = "CalendarGridDayCellContext";
export function useCalendarGridDayCellContext() {
  const context = React.useContext(CalendarGridDayCellContext);
  if (context === undefined) {
    throw /* FIXME (minify-errors-in-prod): Unminified error message in production build! */new Error('MUI: `CalendarGridDayCellContext` is missing. <CalendarGrid.DayEvent /> must be placed within <CalendarGrid.DayCell />.');
  }
  return context;
}